import { Component, OnInit } from '@angular/core';
import { Payment } from '../../models';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { PaymentService } from '../../services/payment.service';
import { ToastsManager } from 'ng2-toastr';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-payment-refund-dialog',
  templateUrl: './payment-refund-dialog.component.html',
  styleUrls: ['./payment-refund-dialog.component.css']
})
export class PaymentRefundDialogComponent implements OnInit {

  payment: Payment;
  form: FormGroup = this.formBuilder.group({
    amountRefunded: [0, Validators.max(0)]
  });
  max: number;

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private paymentService: PaymentService,
    private toastService: ToastsManager
  ) { }

  get amountRefunded(): AbstractControl {
    return this.form.get('amountRefunded');
  }
  ngOnInit() {
    this.max = (this.payment.amount - (this.payment.amountRefunded ? this.payment.amountRefunded : 0)) / 100;
    this.amountRefunded.setValidators([Validators.max(this.max)]);
    this.amountRefunded.setValue(this.max);
  }

  handleRefundSubmit() {
    this.payment.amountRefunded = this.amountRefunded.value * 100;
    this.paymentService.refund(this.payment)
      .pipe(
        catchError(err => {
          this.toastService.error('An error occur ...');
          return of();
        })
      ).subscribe(() => {
        this.toastService.info('Refund done !');
        this.activeModal.close();
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/payment/payment-refund-dialog/payment-refund-dialog.component.ts